import React from 'react';
import PageSection from '../PageSection';

const sectionContainer = 'mx-6 sm:mx-8 md:mx-6 xl:mx-auto xl:w-11/12 xl:max-w-screen-2xl';
const headingClass = 'text-md text-2xl font-bold leading-tight md:text-[48px] xl:text-[64px]';
const paragraphClass = 'leading-[28px] sm:leading-[30px] xl:text-[18px] xl:leading-9';

const TickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="size-6 lg:size-9" viewBox="0 0 36 36" fill="none">
    <path
      d="M1.22852 17.6416C6.24531 23.0697 11.1095 27.9564 15.7853 34.1369C20.8689 24.026 26.072 13.8799 34.6572 2.89213L32.3439 1.83252C25.0947 9.52049 19.4627 16.7978 14.5689 25.4463C11.1658 22.3806 5.66594 18.0424 2.30781 15.8135L1.22852 17.6416Z"
      fill="#70AA80"
    />
  </svg>
);

const installationSteps = [
  {
    step: '01',
    title: 'Scaffolding Setup',
    desc: 'Scaffolding is installed at your property to ensure a safe working environment.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
        <g clipPath="url(#clip0_4006_31030)">
          <path
            d="M27.566 30.3721L31.808 26.1301L43.7999 38.1221L39.5579 42.3641L27.566 30.3721ZM35 20.0281C38.86 20.0281 42 16.8881 42 13.0281C42 11.8681 41.68 10.7881 41.18 9.82814L35.7799 15.2281L32.7999 12.2481L38.2 6.84814C37.24 6.34814 36.16 6.02814 35 6.02814C31.1399 6.02814 28 9.16814 28 13.0281C28 13.8481 28.16 14.6281 28.42 15.3481L24.72 19.0481L21.16 15.4881L22.58 14.0681L19.76 11.2481L24 7.00814C22.8749 5.88453 21.35 5.25342 19.76 5.25342C18.1699 5.25342 16.645 5.88453 15.52 7.00814L8.43995 14.0881L11.26 16.9081H5.61995L4.19995 18.3281L11.28 25.4081L12.7 23.9881V18.3281L15.52 21.1481L16.94 19.7281L20.5 23.2881L5.67995 38.1081L9.91995 42.3481L32.68 19.6081C33.4 19.8681 34.18 20.0281 35 20.0281Z"
            fill="#E76F51"
          />
        </g>
        <defs>
          <clipPath id="clip0_4006_31030">
            <rect width="48" height="48" fill="white" transform="translate(0 0.0283203)" />
          </clipPath>
        </defs>
      </svg>
    ),
    color: '#E76F51',
  },
  {
    step: '02',
    title: 'Mounting Brackets Installation',
    desc: 'Secure brackets are fitted to your roof to support the solar panels.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
        <path
          d="M39 21.7783H35.8125V11.2783C35.8125 7.96426 33.1266 5.27832 29.8125 5.27832H18.1875C14.8734 5.27832 12.1875 7.96426 12.1875 11.2783V21.7783H9C8.17031 21.7783 7.5 22.4486 7.5 23.2783V41.2783C7.5 42.108 8.17031 42.7783 9 42.7783H39C39.8297 42.7783 40.5 42.108 40.5 41.2783V23.2783C40.5 22.4486 39.8297 21.7783 39 21.7783ZM25.3125 32.8877V35.3721C25.3125 35.5783 25.1437 35.7471 24.9375 35.7471H23.0625C22.8562 35.7471 22.6875 35.5783 22.6875 35.3721V32.8877C22.3006 32.6099 22.0118 32.2165 21.8626 31.7641C21.7135 31.3117 21.7118 30.8236 21.8577 30.3702C22.0036 29.9168 22.2897 29.5213 22.6746 29.2408C23.0596 28.9603 23.5237 28.8091 24 28.8091C24.4763 28.8091 24.9404 28.9603 25.3254 29.2408C25.7103 29.5213 25.9964 29.9168 26.1423 30.3702C26.2882 30.8236 26.2865 31.3117 26.1374 31.7641C25.9883 32.2165 25.6994 32.6099 25.3125 32.8877ZM32.4375 21.7783H15.5625V11.2783C15.5625 9.82988 16.7391 8.65332 18.1875 8.65332H29.8125C31.2609 8.65332 32.4375 9.82988 32.4375 11.2783V21.7783Z"
          fill="#F0935C"
        />
      </svg>
    ),
    color: '#F0935C',
  },
  {
    step: '03',
    title: 'Solar Panel & Optimiser Installation',
    desc: 'Panels and optimisers are carefully attached to the mounting brackets.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
        <path
          d="M5.99988 19.5283C5.99988 19.1305 6.15792 18.749 6.43922 18.4677C6.72053 18.1864 7.10206 18.0283 7.49988 18.0283H10.4999C10.8977 18.0283 11.2792 18.1864 11.5605 18.4677C11.8418 18.749 11.9999 19.1305 11.9999 19.5283C11.9999 19.9261 11.8418 20.3077 11.5605 20.589C11.2792 20.8703 10.8977 21.0283 10.4999 21.0283H7.49988C7.10206 21.0283 6.72053 20.8703 6.43922 20.589C6.15792 20.3077 5.99988 19.9261 5.99988 19.5283ZM13.393 11.0439C13.6745 11.3254 14.0562 11.4835 14.4543 11.4835C14.8523 11.4835 15.234 11.3254 15.5155 11.0439C15.797 10.7625 15.9551 10.3807 15.9551 9.9827C15.9551 9.58465 15.797 9.20291 15.5155 8.92145L13.393 6.80082C13.1094 6.53139 12.7318 6.3834 12.3406 6.38841C11.9495 6.39342 11.5758 6.55103 11.2992 6.82763C11.0226 7.10423 10.865 7.47794 10.86 7.86908C10.855 8.26023 11.003 8.63785 11.2724 8.92145L13.393 11.0439ZM23.9999 7.52832C24.3977 7.52832 24.7792 7.37028 25.0605 7.08898C25.3418 6.80768 25.4999 6.42615 25.4999 6.02832V3.02832C25.4999 2.6305 25.3418 2.24896 25.0605 1.96766C24.7792 1.68636 24.3977 1.52832 23.9999 1.52832C23.6021 1.52832 23.2205 1.68636 22.9392 1.96766C22.6579 2.24896 22.4999 2.6305 22.4999 3.02832V6.02832C22.4999 6.42615 22.6579 6.80768 22.9392 7.08898C23.2205 7.37028 23.6021 7.52832 23.9999 7.52832ZM33.5455 11.4827C33.7425 11.4829 33.9377 11.4442 34.1198 11.3689C34.3019 11.2936 34.4674 11.1832 34.6068 11.0439L36.7274 8.92145C36.9968 8.63785 37.1448 8.26023 37.1398 7.86908C37.1348 7.47794 36.9772 7.10423 36.7006 6.82763C36.424 6.55103 36.0503 6.39342 35.6591 6.38841C35.268 6.3834 34.8904 6.53139 34.6068 6.80082L32.4843 8.92145C32.2742 9.13123 32.1312 9.39861 32.0732 9.68974C32.0152 9.98086 32.0449 10.2826 32.1586 10.5569C32.2722 10.8311 32.4646 11.0655 32.7115 11.2303C32.9584 11.3951 33.2487 11.4829 33.5455 11.4827ZM35.9999 19.5283C35.9999 19.9261 36.1579 20.3077 36.4392 20.589C36.7205 20.8703 37.1021 21.0283 37.4999 21.0283H40.4999C40.8977 21.0283 41.2792 20.8703 41.5605 20.589C41.8418 20.3077 41.9999 19.9261 41.9999 19.5283C41.9999 19.1305 41.8418 18.749 41.5605 18.4677C41.2792 18.1864 40.8977 18.0283 40.4999 18.0283H37.4999C37.1021 18.0283 36.7205 18.1864 36.4392 18.4677C36.1579 18.749 35.9999 19.1305 35.9999 19.5283ZM16.4999 21.0283C16.8977 21.0283 17.2792 20.8703 17.5605 20.589C17.8418 20.3077 17.9999 19.9261 17.9999 19.5283C17.9999 17.937 18.632 16.4109 19.7572 15.2857C20.8825 14.1605 22.4086 13.5283 23.9999 13.5283C25.5912 13.5283 27.1173 14.1605 28.2425 15.2857C29.3677 16.4109 29.9999 17.937 29.9999 19.5283C29.9999 19.9261 30.1579 20.3077 30.4392 20.589C30.7205 20.8703 31.1021 21.0283 31.4999 21.0283C31.8977 21.0283 32.2792 20.8703 32.5605 20.589C32.8418 20.3077 32.9999 19.9261 32.9999 19.5283C32.9999 17.1414 32.0517 14.8522 30.3638 13.1644C28.676 11.4765 26.3868 10.5283 23.9999 10.5283C21.6129 10.5283 19.3237 11.4765 17.6359 13.1644C15.9481 14.8522 14.9999 17.1414 14.9999 19.5283C14.9999 19.9261 15.1579 20.3077 15.4392 20.589C15.7205 20.8703 16.1021 21.0283 16.4999 21.0283ZM26.8499 25.5283H21.1499C20.9786 25.5283 20.8125 25.5868 20.6791 25.6943C20.5457 25.8017 20.4532 25.9516 20.4168 26.1189L19.2411 31.5283H28.7586L27.583 26.1189C27.5466 25.9516 27.454 25.8017 27.3207 25.6943C27.1873 25.5868 27.0212 25.5283 26.8499 25.5283ZM5.95301 34.9033L3.18738 39.7896C3.02903 40.0692 2.96469 40.3924 3.00385 40.7114C3.04301 41.0304 3.18359 41.3284 3.40488 41.5614C3.55085 41.7116 3.72588 41.8305 3.91931 41.9107C4.11273 41.991 4.32048 42.031 4.52988 42.0283H13.2843C13.4555 42.0284 13.6217 41.9698 13.755 41.8624C13.8884 41.7549 13.981 41.6051 14.0174 41.4377L15.5174 34.5283H6.60551C6.47335 34.5278 6.3434 34.5622 6.22882 34.6281C6.11424 34.6939 6.01909 34.7889 5.95301 34.9033ZM44.8049 39.7783L42.0468 34.9033C41.9807 34.7889 41.8855 34.6939 41.771 34.6281C41.6564 34.5622 41.5264 34.5278 41.3943 34.5283H32.4805L33.9805 41.4377C34.0169 41.6051 34.1095 41.7549 34.2429 41.8624C34.3762 41.9698 34.5424 42.0284 34.7136 42.0283H43.4549C43.6643 42.031 43.872 41.991 44.0655 41.9107C44.2589 41.8305 44.4339 41.7116 44.5799 41.5614C44.8036 41.3301 44.9469 41.033 44.9888 40.7139C45.0307 40.3949 44.9688 40.0708 44.8124 39.7896L44.8049 39.7783ZM39.5043 30.4033L37.1755 26.2783C37.0442 26.0462 36.8533 25.8533 36.6226 25.7195C36.3919 25.5857 36.1297 25.5158 35.863 25.5171H31.4549C31.3428 25.517 31.2322 25.5421 31.1311 25.5904C31.03 25.6388 30.9411 25.7091 30.8707 25.7963C30.8004 25.8836 30.7505 25.9855 30.7248 26.0945C30.699 26.2035 30.698 26.317 30.7218 26.4264L31.828 31.5171H38.8499C38.9803 31.5168 39.1084 31.4825 39.2216 31.4176C39.3347 31.3527 39.4289 31.2595 39.495 31.147C39.5611 31.0345 39.5967 30.9068 39.5983 30.7764C39.5999 30.646 39.5675 30.5174 39.5043 30.4033ZM16.5449 25.5283H12.1311C11.8644 25.5271 11.6022 25.597 11.3715 25.7308C11.1408 25.8646 10.95 26.0575 10.8186 26.2896L8.49551 30.4033C8.42947 30.5177 8.39481 30.6475 8.39502 30.7795C8.39523 30.9116 8.43031 31.0413 8.49672 31.1554C8.56312 31.2696 8.65849 31.3642 8.77318 31.4297C8.88787 31.4951 9.01782 31.5292 9.14988 31.5283H16.1718L17.278 26.4377C17.3018 26.3282 17.3008 26.2148 17.275 26.1057C17.2492 25.9967 17.1993 25.8948 17.129 25.8076C17.0587 25.7204 16.9697 25.65 16.8686 25.6017C16.7676 25.5533 16.6569 25.5283 16.5449 25.5283ZM29.4111 34.5283H18.5886L17.1561 41.1189C17.1323 41.2284 17.1333 41.3419 17.1591 41.4509C17.1849 41.5599 17.2348 41.6618 17.3051 41.749C17.3754 41.8363 17.4644 41.9066 17.5655 41.955C17.6666 42.0033 17.7772 42.0284 17.8893 42.0283H30.1105C30.2226 42.0284 30.3332 42.0033 30.4343 41.955C30.5354 41.9066 30.6243 41.8363 30.6946 41.749C30.765 41.6618 30.8149 41.5599 30.8406 41.4509C30.8664 41.3419 30.8674 41.2284 30.8436 41.1189L29.4111 34.5283Z"
          fill="#EBBC67"
        />
      </svg>
    ),
    color: '#EBBC67',
  },
  {
    step: '04',
    title: 'Inverter Installation',
    desc: 'The inverter is installed inside your property and connected to the solar panels.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
        <path
          d="M24 8.02832C29.4972 8.02832 34.3498 10.8008 37.2312 15.0283H32V19.0283H44V7.02832H40V12.027C36.3524 7.17164 30.5448 4.02832 24 4.02832C12.9543 4.02832 4 12.9826 4 24.0283H8C8 15.1918 15.1634 8.02832 24 8.02832ZM40 24.0283C40 32.8649 32.8366 40.0283 24 40.0283C18.5029 40.0283 13.6502 37.2557 10.7689 33.0283H16V29.0283H4V41.0283H8V36.0295C11.6476 40.8849 17.4553 44.0283 24 44.0283C35.0456 44.0283 44 35.0739 44 24.0283H40Z"
          fill="#70AA80"
        />
      </svg>
    ),
    color: '#70AA80',
  },
  {
    step: '05',
    title: 'Scaffolding Removal',
    desc: 'Once the installation is complete, the scaffolding is dismantled and removed.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
        <g clipPath="url(#clip0_4006_31075)">
          <path
            d="M26.1209 4.52826C25.5584 3.96585 24.7954 3.6499 23.9999 3.6499C23.2045 3.6499 22.4415 3.96585 21.8789 4.52826L1.93794 24.4663C1.79848 24.6057 1.68785 24.7713 1.61237 24.9535C1.53689 25.1357 1.49805 25.331 1.49805 25.5283C1.49805 25.7255 1.53689 25.9208 1.61237 26.103C1.68785 26.2852 1.79848 26.4508 1.93794 26.5903C2.2196 26.8719 2.60161 27.0302 2.99994 27.0302C3.19717 27.0302 3.39247 26.9913 3.57469 26.9158C3.75691 26.8404 3.92248 26.7297 4.06194 26.5903L23.9999 6.64926L43.9379 26.5903C44.2196 26.8719 44.6016 27.0302 44.9999 27.0302C45.3983 27.0302 45.7803 26.8719 46.0619 26.5903C46.3436 26.3086 46.5018 25.9266 46.5018 25.5283C46.5018 25.1299 46.3436 24.7479 46.0619 24.4663L38.9999 17.4073V7.52826C38.9999 7.13044 38.8419 6.74891 38.5606 6.4676C38.2793 6.1863 37.8978 6.02826 37.4999 6.02826H34.4999C34.1021 6.02826 33.7206 6.1863 33.4393 6.4676C33.158 6.74891 32.9999 7.13044 32.9999 7.52826V11.4073L26.1209 4.52826Z"
            fill="#228F81"
          />
          <path
            d="M24 9.90723L38.136 24.0432C35.64 23.9253 33.1602 24.5025 30.9728 25.7104C28.7854 26.9184 26.9762 28.7097 25.7466 30.885C24.517 33.0603 23.9152 35.5342 24.0083 38.0313C24.1014 40.5283 24.8858 42.9505 26.274 45.0282H10.5C9.30653 45.0282 8.16193 44.5541 7.31802 43.7102C6.47411 42.8663 6 41.7217 6 40.5282V27.9072L24 9.90723Z"
            fill="#228F81"
          />
          <path
            d="M37.5 48.0283C40.2848 48.0283 42.9555 46.9221 44.9246 44.9529C46.8938 42.9838 48 40.3131 48 37.5283C48 34.7435 46.8938 32.0728 44.9246 30.1037C42.9555 28.1346 40.2848 27.0283 37.5 27.0283C34.7152 27.0283 32.0445 28.1346 30.0754 30.1037C28.1062 32.0728 27 34.7435 27 37.5283C27 40.3131 28.1062 42.9838 30.0754 44.9529C32.0445 46.9221 34.7152 48.0283 37.5 48.0283ZM42.537 34.5493L38.532 41.2273C38.356 41.5207 38.1154 41.7701 37.8285 41.9565C37.5417 42.1429 37.216 42.2615 36.8765 42.3031C36.5369 42.3448 36.1923 42.3085 35.8688 42.1969C35.5454 42.0853 35.2517 41.9015 35.01 41.6593L32.688 39.3403C32.4067 39.0587 32.2489 38.6768 32.2492 38.2788C32.2494 37.8807 32.4078 37.4991 32.6895 37.2178C32.9712 36.9366 33.353 36.7787 33.7511 36.779C34.1491 36.7793 34.5307 36.9377 34.812 37.2193L36.453 38.8603L39.963 33.0073C40.0642 32.8383 40.1978 32.6909 40.356 32.5735C40.5142 32.4561 40.694 32.371 40.8851 32.3231C41.0762 32.2752 41.2749 32.2654 41.4698 32.2942C41.6647 32.3231 41.852 32.3901 42.021 32.4913C42.19 32.5926 42.3374 32.7261 42.4548 32.8843C42.5722 33.0426 42.6573 33.2224 42.7052 33.4135C42.7531 33.6046 42.7629 33.8032 42.7341 33.9981C42.7052 34.193 42.6382 34.3803 42.537 34.5493Z"
            fill="#228F81"
          />
        </g>
        <defs>
          <clipPath id="clip0_4006_31075">
            <rect width="48" height="48" fill="white" transform="translate(0 0.0283203)" />
          </clipPath>
        </defs>
      </svg>
    ),
    color: '#228F81',
  },
];

const items = [
  {
    title: '435w Half-Cell 108 Cell Monofacial Solar Module',
    subtitle: 'Model',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
        <g clipPath="url(#clip0_4027_6899)">
          <path
            d="M18.4185 2.50442C18.1499 2.39676 17.8501 2.39676 17.5815 2.50442L4.1535 7.87516L18 13.4124L31.8465 7.87516L18.4185 2.50442ZM33.75 9.53791L19.125 15.3879V33.2124L33.75 27.3624V9.53791ZM16.875 33.2147V15.3857L2.25 9.53791V27.3647L16.875 33.2147ZM16.7467 0.414165C17.5513 0.0924136 18.4487 0.0924136 19.2533 0.414165L35.2935 6.83116C35.502 6.91474 35.6808 7.05885 35.8067 7.24492C35.9326 7.43099 35.9999 7.65049 36 7.87516V27.3647C35.9997 27.8143 35.8647 28.2535 35.6125 28.6256C35.3602 28.9978 35.0023 29.2859 34.5848 29.4527L18.4185 35.9192C18.1499 36.0268 17.8501 36.0268 17.5815 35.9192L1.4175 29.4527C0.999565 29.2862 0.64112 28.9983 0.388445 28.6261C0.135769 28.2539 0.000464241 27.8145 0 27.3647L0 7.87516C5.22899e-05 7.65049 0.0673734 7.43099 0.193291 7.24492C0.319208 7.05885 0.497954 6.91474 0.7065 6.83116L16.7467 0.414165Z"
            fill="#264653"
          />
        </g>
        <defs>
          <clipPath id="clip0_4027_6899">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    title: '1724mm × 1134mm × 30mm',
    subtitle: 'Dimensions',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
        <path
          d="M9 0V36H27V0H9ZM11.25 2.25H24.75V5.625H16.875V7.875H24.75V10.125H20.25V12.375H24.75V14.625H16.875V16.875H24.75V19.125H20.25V21.375H24.75V23.625H16.875V25.875H24.75V28.125H20.25V30.375H24.75V33.75H11.25V2.25Z"
          fill="#264653"
        />
      </svg>
    ),
  },
  {
    title: 'Black',
    subtitle: 'Colour',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M15.48 6.95015C14.335 5.25765 13.1625 3.83015 12.105 2.84265C11.5796 2.32884 10.9815 1.89504 10.33 1.55515C9.78746 1.29515 8.92996 1.04265 8.12496 1.50515C7.20746 2.03765 7.05746 3.08015 7.04996 3.74515C7.04246 4.50515 7.20996 5.40515 7.48246 6.35515C7.97246 8.07265 8.87246 10.1751 10.07 12.3602L1.87996 20.5502C1.18746 21.2427 1.20746 22.1901 1.33496 22.8451C1.47246 23.5526 1.80246 24.3277 2.23496 25.1026C3.10496 26.6702 4.53496 28.5051 6.29996 30.2726C8.06746 32.0401 9.90246 33.4676 11.47 34.3377C12.245 34.7701 13.02 35.1002 13.7275 35.2377C14.3825 35.3627 15.3275 35.3852 16.0225 34.6926L30.06 20.6552C30.355 21.2977 30.29 21.9352 30.185 23.0027C30.11 23.7327 30.015 24.6651 30.0025 25.9426V26.2501H30.01C30.0624 26.8748 30.3475 27.457 30.8089 27.8813C31.2704 28.3057 31.8743 28.5412 32.5012 28.5412C33.1281 28.5412 33.7321 28.3057 34.1935 27.8813C34.6549 27.457 34.9401 26.8748 34.9925 26.2501H35V26.1076C35.0023 26.01 34.999 25.9124 34.99 25.8152C34.8525 22.6902 33.24 18.9701 30.34 17.0802C30.1861 16.7082 30.01 16.3459 29.8125 15.9952C28.94 14.4302 27.5125 12.5952 25.745 10.8277C23.9775 9.06015 22.1425 7.63015 20.575 6.76015C19.8 6.33015 19.025 6.00015 18.3175 5.86015C17.6625 5.73515 16.7175 5.71515 16.0225 6.40765L15.48 6.95015ZM10.4 4.66765C11.3525 5.55765 12.51 6.97265 13.6775 8.74765L11.9175 10.5102C10.9625 8.69265 10.2675 7.00515 9.88496 5.66515C9.71767 5.11721 9.60791 4.55333 9.55746 3.98265C9.78579 4.13265 10.0666 4.36098 10.4 4.66765ZM11.385 14.5802C12.735 16.7102 14.1525 18.4977 15.4025 19.6627C15.5226 19.7746 15.6637 19.8618 15.8175 19.9192C15.9714 19.9767 16.135 20.0033 16.2992 19.9975C16.4633 19.9917 16.6247 19.9536 16.7741 19.8854C16.9235 19.8172 17.058 19.7203 17.17 19.6002C17.2819 19.48 17.3691 19.339 17.4265 19.1851C17.484 19.0312 17.5106 18.8676 17.5048 18.7035C17.499 18.5393 17.4609 18.378 17.3927 18.2285C17.3246 18.0791 17.2276 17.9446 17.1075 17.8327C15.975 16.7777 14.565 14.9927 13.1975 12.7652L15.9175 10.0452C16.0525 10.3468 16.205 10.651 16.375 10.9577C17.2475 12.5252 18.675 14.3602 20.4425 16.1277C22.2075 17.8952 24.0425 19.3227 25.6125 20.1926C25.9175 20.3643 26.2216 20.5168 26.525 20.6502L14.3725 32.8051L14.2025 32.7802C13.86 32.7127 13.3475 32.5201 12.6825 32.1501C11.3725 31.4201 9.71746 30.1501 8.06746 28.5001C6.41746 26.8501 5.14746 25.2001 4.41746 23.8851C4.04996 23.2226 3.85496 22.7101 3.78996 22.3676L3.76496 22.1976L11.385 14.5802ZM18.56 9.74265C18.3002 9.30271 18.0978 8.8314 17.9575 8.34015C18.295 8.42265 18.7675 8.61515 19.3625 8.94265C20.6725 9.67265 22.3275 10.9427 23.9775 12.5927C25.1025 13.7177 26.0525 14.8452 26.7725 15.8677C25.8777 15.8065 24.9789 15.8832 24.1075 16.0952C23.4474 15.5468 22.8134 14.9678 22.2075 14.3602C20.5575 12.7102 19.29 11.0552 18.5625 9.74265H18.56Z"
          fill="#264653"
        />
      </svg>
    ),
  },
  {
    title: '21.0kg',
    subtitle: 'Weight',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M5 7.5V32.5H35V7.5H5ZM7.5 10H32.5V30H7.5V10ZM20 12.5C14.585 12.5 10.5469 15.1953 10.5469 15.1953L9.57031 15.8594L10.1953 16.875L13.9453 23.125L14.2969 23.75H25.7031L26.0547 23.125L29.8047 16.875L30.4297 15.8594L29.4531 15.1953C29.4531 15.1953 25.415 12.5 20 12.5ZM20 15C23.5303 15 25.8594 16.1328 26.9922 16.7578L24.3359 21.25H22.0312L23.6328 18.0469L21.3672 16.9531L19.2188 21.25H15.6641L13.0078 16.7578C14.1406 16.1328 16.4697 15 20 15Z"
          fill="#264653"
        />
      </svg>
    ),
  },
];

const SolarPvSystemPage = () => {
  return (
    <div className="flex min-h-screen flex-col gap-10 bg-white lg:gap-12 xl:gap-16">
      <div id="finance-intro" className={`${sectionContainer} mt-10 flex flex-col gap-4 md:mt-12 lg:gap-6`}>
        <h2 className={headingClass}>Solar PV System Information</h2>
        <p className="font-jost text-[#516B75] md:text-[20px] xl:text-[24px]">
          High-performance solar energy for your home
        </p>
      </div>

      <PageSection title="About UKSOL" containerClassName={sectionContainer}>
        <div className="flex flex-col gap-4 xl:gap-6">
          <p className={paragraphClass}>
            UKSOL is a British family-owned company specialising in high-quality, efficient, and reliable solar panels.
            Designed to withstand harsh weather conditions, UKSOL panels use advanced technology and premium materials
            to maximise energy output, ensuring long-lasting performance and sustainability.
          </p>

          <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2">
            {items.map(({ title, subtitle, icon }, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="shrink-0">{icon}</div>
                <div>
                  <p className="font-bold leading-7 xl:text-[18px]">{title}</p>
                  <p className="leading-7 text-[#516B75] xl:text-[18px]">{subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </PageSection>

      <div className="bg-[#F8F9FA]">
        <div className={`${sectionContainer} m-6 flex flex-col justify-between gap-6 sm:flex-col md:flex-row`}>
          <div className="flex flex-col justify-between">
            {['uk-sol-logo.png', 'solar-panel.png'].map((img, i) => (
              <div
                key={i}
                className={`
      ${
        i === 0
          ? 'h-[60px] bg-contain bg-left lg:w-[250px]'
          : 'h-[200px] origin-center rotate-0 bg-contain bg-center md:size-[200px] md:rotate-90 md:bg-left lg:w-[300px] lg:rotate-0 lg:bg-center'
      }
      bg-no-repeat
    `}
                style={{
                  backgroundImage: `url('/images/solar-pv-system/${img}')`,
                  backgroundColor: '#F8F9FA',
                  backgroundBlendMode: 'darken',
                }}
              />
            ))}
            <div>
              <p className="font-bold leading-7 xl:text-[18px]">UKSOL</p>
              <p className="leading-7 text-[#516B75] xl:text-[18px]">Solar Panel</p>
            </div>
          </div>
          <div className="flex flex-col justify-between">
            {['tigo-logo.jpg', 'tigo.png'].map((img, i) => (
              <div
                key={i}
                className={`
        ${i === 0 ? 'my-2 h-10 bg-contain bg-left lg:h-[50px] lg:w-[105px]' : 'h-[200px] bg-contain bg-center md:size-[200px] lg:w-[300px]'}
        bg-no-repeat
      `}
                style={{
                  backgroundImage: `url('/images/solar-pv-system/${img}')`,
                  backgroundColor: '#F8F9FA',
                  backgroundBlendMode: 'darken',
                }}
              />
            ))}
            <div>
              <p className="font-bold leading-7 xl:text-[18px]">Tigo</p>
              <p className="leading-7 text-[#516B75] xl:text-[18px]">Solar Optimisers</p>
            </div>
          </div>
          <div className="flex flex-col justify-between">
            {['sola-x-logo.png', 'sola-x.jpg'].map((img, i) => (
              <div
                key={i}
                className={`
        ${i === 0 ? 'h-[60px] bg-contain bg-left lg:max-w-[130px]' : 'h-[200px] bg-contain bg-center md:size-[200px] lg:w-[300px]'}
        bg-no-repeat
      `}
                style={{
                  backgroundImage: `url('/images/solar-pv-system/${img}')`,
                  backgroundColor: '#F8F9FA',
                  backgroundBlendMode: 'darken',
                }}
              />
            ))}
            <div>
              <p className="font-bold leading-7 xl:text-[18px]">SolaX Power</p>
              <p className="leading-7 text-[#516B75] xl:text-[18px]">Solar Inverter</p>
            </div>
          </div>
        </div>
      </div>

      <PageSection title="Installation" containerClassName={sectionContainer}>
        <div className="mb-10 flex flex-col gap-10 lg:flex-row xl:mb-20 xl:gap-20">
          <div className="lg:w-1/2">
            <p className="font-jost mb-4 text-[20px] font-medium md:text-[24px]">Installation Steps</p>
            <div className="flex flex-col gap-4">
              {installationSteps.map(({ step, title, desc, icon, color }) => (
                <div
                  key={step}
                  className="flex w-full items-center gap-4 rounded-[10px] bg-white p-4 lg:rounded-[20px]"
                  style={{
                    boxShadow: '0px 0px 10px 0px rgba(21, 53, 66, 0.15)',
                    alignSelf: 'stretch',
                  }}
                >
                  <div className="mr-4 text-center">
                    <p className="text-[17px] font-extrabold text-[#748991] xl:text-[19px]">STEP</p>
                    <p
                      className="text-[40px] font-[900] leading-[50px] xl:text-[48px]"
                      style={{
                        color,
                      }}
                    >
                      {step}
                    </p>
                  </div>
                  <div className="flex-1">
                    <p className={`font-semibold ${paragraphClass}`}>{title}</p>
                    <p className={`text-[#516B75] ${paragraphClass}`}>{desc}</p>
                  </div>
                  <div className="ml-4 hidden text-2xl sm:flex">{icon}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col justify-between lg:w-1/2">
            <div>
              <p className="font-jost mb-4 text-[20px] font-medium md:text-[24px]">Installation Duration</p>
              <p className={`mb-6 ${paragraphClass}`}>
                Installing your Solar PV System typically takes 1-2 days. However, please note that scaffolding assembly
                and disassembly occur before and after installation, which may slightly extend the overall process.
              </p>
            </div>
            <div>
              <p className="font-jost mb-4 text-[20px] font-medium md:text-[24px]">Add-Ons Installation</p>
              <p className={`mb-4 ${paragraphClass}`}>If you're including any additional features, such as:</p>
              <ul className="mb-6 list-inside list-disc space-y-2">
                <li className={paragraphClass}>Smart Monitoring</li>
                <li className={paragraphClass}>Battery Storage</li>
                <li className={paragraphClass}>Bird Deterrent Mesh</li>
              </ul>
              <p className={`mb-6 ${paragraphClass}`}>
                These will be installed alongside your solar PV system without increasing the installation timeframe.
              </p>
            </div>
            <div>
              <p className="font-jost mb-4 text-[20px] font-medium md:text-[24px]">Warranties & Guarantees</p>
              <ul className="space-y-4">
                <li className="flex items-center gap-3">
                  <TickIcon />
                  <p>Manufacturer Warranty</p>
                </li>
                <li className="flex items-center gap-3">
                  <TickIcon />
                  <p>Material & Workmanship Guarantee</p>
                </li>
                <li className="flex items-center gap-3">
                  <TickIcon />
                  <p>Insurance Backed Guarantee</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </PageSection>
    </div>
  );
};

export default SolarPvSystemPage;
